import React, { useContext, useEffect, useState, useRef } from "react";
import { Grid, Box } from '@mui/material';
import { MyContext } from '../../../context/MyContext';
import api from '../../../services/api';
import { useHistory } from 'react-router-dom';
import { Typography } from '@mui/material';
import CardMedia from '@mui/material/CardMedia';
import RemoveIcon from '@mui/icons-material/Remove';
import TextField from '@mui/material/TextField';
import AddIcon from '@mui/icons-material/Add';
import IconButton from '@mui/material/IconButton';
import { Cookies } from 'react-cookie';
import { ToastContainer, toast } from 'react-toastify';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import CloseIcon from '../../../assets/img/close.svg';
import Carrossel_mini from '../../Carrossel_mini/Carrossel_mini';
import Backdrop from '@mui/material/Backdrop';
import Dialogo from '../../Dialogo/Dialogo';
import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import Avatar from '@mui/material/Avatar';
import { fontSize } from "@mui/system";
import { BrowserView, MobileView } from 'react-device-detect';
import AddAlertIcon from '@mui/icons-material/AddAlert';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { ja } from "date-fns/locale";

function DetalhesProduto(props) {
  let navigate = useHistory();
  //const [open, setOpen] = useState(false);
  const { reloadCodigo, setReloadCodigo } = useContext(MyContext);
  const [aplicacoes, setAplicacoes] = useState([]);
  const [corTexto, setCorTexto] = useState("#F000000");
  const [isDisplay, setIsDisplay] = useState(true);
  const [retornoApiSimultaneos, setRetornoApiSimultaneos] = useState([]);
  const [openQuestion, setOpenQuestion] = useState(false);
  const { openMD, setOpenMD } = useContext(MyContext);
  const { carrinhoCounter, setCarrinhoCounter } = useContext(MyContext);
  const { ultimaPesquisaProdutos, setUltimaPesquisaProdutos } = useContext(MyContext);
  const { meuCarrinho, setMeuCarrinho } = useContext(MyContext);
  const { meuFormaPagamentoTipo, setMeuFormaPagamentoTipo } = useContext(MyContext); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
  const { showModalDetalhes, setShowModalDetalhes } = useContext(MyContext);
  const [cepEntregaSelecionado, setCepEntregaSelecionado] = useState({});
  const [openDialogo, setOpenDialogo] = useState(false);
  const [dialogoMensagem, SetDialogoMensagem] = useState("");
  // const [dialogoRetornoSim, setDialogoRetornoSim] = useState(false);
  const [dialogoProduto, setDialogoProduto] = useState({});
  const [totalGeral, setTotalGeral] = useState(0.00);
  const [descontoPagamentoAVista, setDescontoPagamentoAVista] = useState({});
  const [totalDescontos, setTotalDescontos] = useState(0.00);
  const [cepDigitado, setCepDigitado] = useState("");
  const [freteError, setFreteError] = useState("");
  const [fretes, setFretes] = useState([]);
  const [tipoFrete, setTipoFrete] = useState(-1);
  const [hasCep, setHasCep] = useState(false);
  const [totalFrete, setTotalFrete] = useState(0.00);
  const [totalProdutos, setTotalProdutos] = useState(0.00);
  const [totalCreditos, setTotalCreditos] = useState(0.00);
  const [cartaoTipoCartao, setCartaoTipoCartao] = useState(0);
  const [pagamentoNumeroMaximoParcelas, setPagamentoNumeroMaximoParcelas] = useState({});
  const [pagamentoNumeroParcelas, setPagamentoNumeroParcelas] = useState(0);
  const [pagamentoNumeroParcelasError, setPagamentoNumeroParcelasError] = useState("");
  const [pagamentoValorParcelas, setPagamentoValorParcelas] = useState([]);
  const [cartaoSolicitarCPF_CNPJ, setCartaoSolicitarCPF_CNPJ] = useState(true);
  const [pagamentoOpcaoSelecionada, setPagamentoOpcaoSelecionada] = useState("");
  const { meusCreditosSelecionados, setMeusCreditosSelecionados } = useContext(MyContext);  // Créditos Selecionados Para Pagamentos
  const [dialogoRetornoSim, setDialogoRetornoSim] = useState(false);
  const [ultimaMontadora, setUltimaMontadora] = useState(-9999);
  const uniqueValues = [];
  const [montadoras, setMontadoras] = useState([]);
  const { codigoReload, setCodigoReload } = useContext(MyContext);

  const [produto, setProduto] = useState([]);
  // const produto = props?.props;

  useEffect(() => {
    //if (produto.codigo != 0) {      
      if (props != null && props?.props != null)
      {

        console.log("SetProduto ", props);

       setProduto(props?.props);
       buscarAplicacoesProdutos(props?.props.codigo);
       BuscarItensVendidosSimultaneamente(props?.props.codigo, ultimaPesquisaProdutos, 8);
       setShowModalDetalhes(true);
      }
    //}
  }, []);

  useEffect(() => {
    if (codigoReload != undefined && codigoReload != 0) {    
      
      console.log("codigoReload ", codigoReload);

      PesquisarProdutoReload(codigoReload);
      buscarAplicacoesProdutos(codigoReload);
      BuscarItensVendidosSimultaneamente(codigoReload, ultimaPesquisaProdutos, 8);
      // setShowModalDetalhes(true);
    }
  }, [codigoReload]);

  useEffect(() => {
    setCorTexto(aplicarCor());
  }, [corTexto]);

  function AviseMe(event, produto) {

  }

  function BuscarItensVendidosSimultaneamente(_codigo, _palavrasPesquisadas, _limite) {
    api.get(`Produtos/vendidosJuntos/${_codigo}/${_palavrasPesquisadas}/${_limite}`).then((response) => {
      if (response == null || response?.data == null) {
        setRetornoApiSimultaneos([]);
      }
      else {
        console.log("retornoApiSimultaneos", retornoApiSimultaneos);
        setRetornoApiSimultaneos(response.data);
      }
    }).catch((e) => {
      if (e == "Error: Network Error") {
        toastErroApiNaoResponde();
        setFreteError("Ops, Nosso Servidor Não Respondeu...");
        return null;
      }
    })
  }

  const toastErroApiNaoResponde = () => toast.error("Ops, Alguma Coisa Errada com Nosso Servidor!",
    { position: toast.POSITION.TOP_CENTER, theme: "colored" });

  const toastMensagemError = (message) => toast.error(message,
    { position: toast.POSITION.TOP_CENTER, theme: "colored", autoClose: 2000 });

  const handleCloseNao = () => {
    setDialogoProduto({});
    setDialogoRetornoSim(false);
    setOpenDialogo(false);
  };

  const handleCloseSim = () => {
    setDialogoRetornoSim(true);
    DeletarCarrinho(dialogoProduto);
    setOpenDialogo(false);
  };

  const modalStyle = {
    position: 'absolute',
    top: '10%',
    left: '10%',
    right: "10%",
    overflow: 'scroll',
    height: '100%',
    display: 'block',
    bgcolor: 'background.paper',
    boxShadow: 24
  }

  const modalStyleQuestions = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '3px solid #008000',
    boxShadow: 24,
    p: 4,
  };

  function DividirParcelamentosCartoes() {
    var _valorDasParcelas = [];
    var _valorTotal = (totalProdutos + totalFrete - totalDescontos - totalCreditos);
    for (let i = 1; i <= Number(pagamentoNumeroMaximoParcelas?.prestacao ?? 1); i++) {
      _valorDasParcelas.push(i + ' x ' + (_valorTotal / i).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) + ' sem juros');
    }
    return (_valorDasParcelas);
  }

  function TelaTipoDeCartaoCreditoOuDebito(modeloCartao) {
    // 0 - Cartão de Crédito / 1 -Cartão de Débito
    // 0 - Cartão de Crédito
    if (modeloCartao == 0) {
      setCartaoSolicitarCPF_CNPJ(true);
      setCartaoTipoCartao(0);
      setPagamentoNumeroParcelas(0);
      setPagamentoOpcaoSelecionada("");
      setPagamentoNumeroParcelasError("");
    }
    // 1 -Cartão de Débito
    else if (modeloCartao == 1) {
      setCartaoSolicitarCPF_CNPJ(false);
      setCartaoTipoCartao(1);
      setPagamentoNumeroParcelas(1);
      setPagamentoOpcaoSelecionada("");
      setPagamentoNumeroParcelasError("");
    }
  }

  function TipoPagamento(value) {
    if (value <= 2) {
      setPagamentoNumeroMaximoParcelas({ prestacao: 1 });
      setCartaoTipoCartao(0);
      TelaTipoDeCartaoCreditoOuDebito(0);
    } else {
      api.get('Prazos/' + totalGeral).then((response) => {
        setPagamentoNumeroMaximoParcelas(response?.data);
        setCartaoTipoCartao(0);
        TelaTipoDeCartaoCreditoOuDebito(0);
      }).catch((e) => {
        console.log(e);
      })
    }
    if (meuFormaPagamentoTipo != value) {
      setMeuFormaPagamentoTipo(value); // Tipo de Pagamento 1 - PIX / 2 - BOLETO / 3 - CARTÃO CRÉDITO ou DÉBITO
    }
  }  

  const PesquisarProdutoReload = async (_codigo) => {
    const data = await api.get(`Produtos/ProdutoDireto/${_codigo}`)
      .then((res) => {

        console.log("UNIQUe 3", res);
        console.log("UNIQUe 5", res?.data[0]);

        setProduto(res?.data[0]);
        
      }).catch(err => {
        // setProduto([]);
        console.log(err);
        console.log("UNIQUe 4");
        //this.setState({ error: err });
        //throw err;
      });
  }

  function AtualizarContadorCarrinho(_meuCarrinho) {
    if (_meuCarrinho != null) {
      let _NumeroProdutosSelecionados = 0;
      _meuCarrinho.map((prod) => {
        _NumeroProdutosSelecionados += Number(prod.quantidade);
      });
      setCarrinhoCounter(_NumeroProdutosSelecionados ?? 0);
    }
  }

  function AdicionarCarrinho(event, produto) {
    let jaExiste = meuCarrinho.find(function (jaExiste) {
      return jaExiste.codigo == produto.codigo
    })
    if (jaExiste) {
      jaExiste.quantidade += 1;
      if (jaExiste.quantidade > produto.quantidadedisponivel) {
        jaExiste.quantidade = produto.quantidadedisponivel
      }
      let _novaQuantidade = meuCarrinho.slice(jaExiste);
      setMeuCarrinho(_novaQuantidade)
      window.setCookie("nafil_carrinho", JSON.stringify(_novaQuantidade), 31);
      AtualizarContadorCarrinho(_novaQuantidade);
    } else {
      if (meuCarrinho.length === 0) {
        produto.quantidade = 1;
        setMeuCarrinho([produto]);
        window.setCookie("nafil_carrinho", JSON.stringify([produto]), 31);
        AtualizarContadorCarrinho([produto]);
      }
      else {
        produto.quantidade = 1;
        const novaArray = [...meuCarrinho, produto];
        setMeuCarrinho(novaArray);
        window.setCookie("nafil_carrinho", JSON.stringify(novaArray), 31);
        AtualizarContadorCarrinho(novaArray);
      }
    }
  }

  function RemoverCarrinho(event, produto) {
    let jaExiste = meuCarrinho.find(function (jaExiste) {
      return jaExiste.codigo == produto.codigo
    })
    if (jaExiste) {
      jaExiste.quantidade -= 1;
      if (jaExiste.quantidade <= 0) {
        jaExiste.quantidade = 0;
        let novoCarrinho = meuCarrinho.slice(jaExiste)
        setMeuCarrinho(novoCarrinho);
        window.setCookie("nafil_carrinho", JSON.stringify(novoCarrinho), 31);
        AtualizarContadorCarrinho(novoCarrinho);
        DeletarCarrinho(produto); // ESSE AQUI ESTÁ EM TESTE
      }
      else {
        setMeuCarrinho(meuCarrinho);
        window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
        AtualizarContadorCarrinho(meuCarrinho);
      }
    }
  }

  // function DeletarCarrinho(produto) {
  //   let jaExiste = meuCarrinho.find(function (jaExiste) {
  //     return jaExiste.codigo == produto.codigo
  //   })
  //   var _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
  //   if (jaExiste) {
  //     // DeletarItemCarrinho(event, produto, open, setOpen);
  //     jaExiste.quantidade = 0;
  //     if (jaExiste.quantidade <= 0) {
  //       jaExiste.quantidade = 0;
  //     }
  //   }
  //   _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
  //   setMeuCarrinho(_meuCarrinhoAntesSet);
  //   window.setCookie("nafil_carrinho", JSON.stringify(_meuCarrinhoAntesSet), 31);
  //   AtualizarContadorCarrinho();
  //   Recalculos();
  //   AtualizarContadorCarrinho();
  // }


  function DeletarCarrinho(produto) {
    let jaExiste = meuCarrinho.find(function (jaExiste) {
        return jaExiste.codigo == produto.codigo
    })
    var _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
    if (jaExiste) {
        // DeletarItemCarrinho(event, produto, open, setOpen);
        jaExiste.quantidade = 0;
        if (jaExiste.quantidade <= 0) {
            jaExiste.quantidade = 0;
        }
    }
    _meuCarrinhoAntesSet = meuCarrinho.filter(x => x.quantidade > 0);
    setMeuCarrinho(_meuCarrinhoAntesSet);
    window.setCookie("nafil_carrinho", JSON.stringify(_meuCarrinhoAntesSet), 31);
    AtualizarContadorCarrinho();
}




  function ItenJaNoCarrinho(produto) {
    let jaExiste = meuCarrinho.find(function (jaExiste) {
      return jaExiste.codigo == produto.codigo
    })
    if (jaExiste && jaExiste.quantidade > 0) {
      return true;
    }
    return false;
  }

  function Recalculos() {
    var ultimoCEPDigitado = window.getCookie('nafil_ultimo_cep');
    // if (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0)
    // {
    //     PegarDescontoAVista();            
    // }
    let __totalProdutos = 0.00;
    let __totalFrete = 0.00;
    let __totalDescontos = 0.00;
    let __totalCreditos = 0.00;

    if (meusCreditosSelecionados != null && meusCreditosSelecionados.length > 0) {
      __totalCreditos = meusCreditosSelecionados.reduce((totalCreditos, item) => {
        return totalCreditos + item.valor;
      }, 0);
      setTotalCreditos(__totalCreditos);
    }
    else {
      __totalCreditos = 0.00;
      setTotalCreditos(__totalCreditos);
    }

    if (cepEntregaSelecionado != null && Object.keys(cepEntregaSelecionado).length > 0 && tipoFrete != -1) {
      __totalFrete = cepEntregaSelecionado.price;
      setTotalFrete(__totalFrete);
    }
    else {
      __totalFrete = 0.00;
      setTotalFrete(__totalFrete);
    }

    if (ultimoCEPDigitado) {
      setCepDigitado(ultimoCEPDigitado);
      var antes = document.getElementById("cepFrete");
      if (antes) {
        if (antes?.value?.length == 0) {
          antes.value = ultimoCEPDigitado;
        }
      }
    }

    __totalProdutos = meuCarrinho.reduce((totalProdutos, item) => {
      return totalProdutos + (item.quantidade * item.preco);
    }, 0);

    setTotalProdutos(__totalProdutos);

    if (meuFormaPagamentoTipo == -1) {
      if (meuFormaPagamentoTipo <= 1) {
        TipoPagamento(1);
      } else {
        TipoPagamento(meuFormaPagamentoTipo);
      }
    }

    let _percentualDescontoAVista = (descontoPagamentoAVista == null || Object.keys(descontoPagamentoAVista).length === 0 ? 0.00 : 1 + (descontoPagamentoAVista.juros / 100));
    __totalDescontos = (meuFormaPagamentoTipo <= 2 && __totalProdutos > descontoPagamentoAVista?.minimo ? __totalProdutos - (__totalProdutos * _percentualDescontoAVista) : 0.00);

    setTotalDescontos(__totalDescontos);
    setTotalGeral(Number((__totalProdutos + __totalFrete - __totalDescontos - __totalCreditos).toFixed(2)));
    setPagamentoValorParcelas(DividirParcelamentosCartoes());

    var elem = document.getElementById('cepFrete');
    if (typeof elem !== 'undefined' && elem !== null) {
      if (cepDigitado != document.getElementById('cepFrete').value) {
        PesquisarCEP(cepDigitado, null);  // Efetua Cotação dos Fretes Pelo Melhor Envio
      }
    }
  }

  function PesquisarCEP(value, event) {
    if (value == null || value == "") {
      document.getElementById("cepFrete").value = "";
      setCepDigitado("");
      setHasCep(false);
      window.setCookie('nafil_ultimo_cep', '', 365);
      return;
    }
    setHasCep(true);
    if (event != null && event.key == "Backspace") {
      if (value.replace("-", "").length == 6) {
        value = value.substr(0, 5);
        return;
      }
      return;
    }
    else {
      if (event != null && event.key != "Delete" && event.key != "Tab" && (event.key != 0 && event.key != 1 && event.key != 2 && event.key != 3 && event.key != 4 && event.key != 5 && event.key != 6 && event.key != 7 && event.key != 8 && event.key != 9)) {
        event.preventDefault();
        return;
      }
    }
    if (value != null && value.indexOf('-') == -1 && value.replaceAll("-", "").length == 5) {
      var antes = document.getElementById("cepFrete");
      antes.value = value + "-";
      if (event != null) {
        setFretes([]);
        setFreteError("");
      }
    }
    if (value != null && value.replaceAll("-", "").length < 5 && value.indexOf('-') != -1) {
      var antes = document.getElementById("cepFrete");
      antes.value = value.replace("-", "");
      if (event != null) {
        setFretes([]);
        setFreteError("");
      }
    }
    if (value != null && value.replaceAll("-", "").length == 8) {
      let _cepSemMascara = value.replaceAll("-", "");
      let _cepComMascara = _cepSemMascara.substr(0, 5) + "-" + _cepSemMascara.substr(5, 3);
      // CEP 27281-510 = 9
      if (cepDigitado != _cepComMascara) {
        setCepDigitado(_cepComMascara);
        setFreteError("Aguarde...");
      }

      // Montar Caixas Para o Cálculo do Envio 
      let _caixaMontada = { cep: "", quantidadeCaixas: 1, listaItensNaCaixa: [] };

      var itensNaCaixa = [];
      meuCarrinho.map((e) => {
        let _itm = {
          // cep: _cepSemMascara, 
          codigo: e.codigo,
          quantidade: e.quantidade,
          preco: e.preco,
          desconto: 0.00, // ARRUMAR
          peso: e.peso,
          largura: e.largura,
          comprimento: e.comprimento,
          altura: e.altura
        };

        itensNaCaixa.push(_itm);
      });
      _caixaMontada = { cep: _cepSemMascara, quantidadeCaixas: 1, listaItensNaCaixa: itensNaCaixa };
    }
    if (value != null && value.length != 9) {
      if (event != null) {
        setFretes([]);
        setFreteError("");
      }
    }
  }

  const buscarAplicacoesProdutos = async (_codigo) => {
    await api.get(`Aplica/${_codigo}`).then((response) => {
      if (response == null || response?.data == null) {
        setAplicacoes([]);
      }
      else {
        setAplicacoes(response.data);
      }
    }).catch((e) => {
      if (e == "Error: Network Error") {
        toastErroApiNaoResponde();
        setFreteError("Ops, Nosso Servidor Não Respondeu...");
        return null;
      }
    })
  }

  function buscarMontadoras() {
    api.get(`Montadoras`).then((response) => {
      if (response == null || response?.data == null) {
        setMontadoras([]);
      }
      else {
        setMontadoras(response.data);
      }
    }).catch((e) => {
      if (e == "Error: Network Error") {
        toastErroApiNaoResponde();
        setFreteError("Ops, Nosso Servidor Não Respondeu...");
        return null;
      }
    })
  }

  function handleChange(e, produto) {
    let jaExiste = meuCarrinho.find(function (jaExiste) {
      return jaExiste.codigo == produto.codigo
    })
    if (jaExiste) {
      jaExiste.quantidade = e.target.value;
      if (jaExiste.quantidade > produto.quantidadedisponivel) {
        jaExiste.quantidade = produto.quantidadedisponivel
      }
      setMeuCarrinho(meuCarrinho.slice(jaExiste))
    }
    window.setCookie("nafil_carrinho", JSON.stringify(meuCarrinho), 31);
    AtualizarContadorCarrinho();
  }

  function DeletarItemCarrinho(event, produto) {
    setOpenDialogo(true);
  }

  function aplicarCor(aplica) {
    if (aplica == null) {
      return "#000000";
    }
    else if (aplica.indice == -3) {
      return "#f44336";
    }
    else if (aplica.indice == -1) {
      return "#000000";
    }
    else if ([4, 6, 9].includes(aplica.indice)) {
      return "#707b7c";
    }
    else if (aplica.indice == 12) {
      return "#ffffff";
    }
  }

  const mostrarCampoOuImagem = (aplica) => {
    if (aplica == null) {
      return null;
    }
    else if (!uniqueValues.includes(aplica.fabricante)) {
      uniqueValues.push(aplica.fabricante);
      if (aplica.indice == -3) {
        return (<Typography sx={{ color: "red", fontStyle: "Bold" }} fontWeight={"Bold"} fontSize={"14px"}>{aplica.fabricante}</Typography>);
      } else if (aplica.indice == 12) {
        return null;
      }
      else {
        return (<Typography sx={{ color: "blue", fontStyle: "Bold" }} fontWeight={"Bold"} fontSize={"14px"}>{aplica.fabricante}</Typography>);
      }
    }
    else {
      return (<Typography sx={{ color: "black", fontStyle: "Bold" }} fontWeight={"Bold"} fontSize={"14px"}>{aplica.montadora}</Typography>);
    }
  }

  const fecharModalDetalhes = (e) => {    
    setShowModalDetalhes(false);
    setOpenMD(false);
  }

  //const produto = props?.props.props;
  //const imagem = "https://www.nafil.com.br/images/produtos/gr/" + produto?.codigo.toString().substr(0, 1) + "/" + produto.codigo.toString() + ".jpg"; //trazendo do site antigo a titulo de teste


 
 if (typeof(produto) == 'object' && produto != null) {
  return (
    (showModalDetalhes
      ?
      <>
        <BrowserView>
          <Grid
            container
            spacing={0}
            direction="row"
            alignItems="left"
            justify="left"
            display="flex"
            columns={12}
            bgcolor="#F5F5F5"
          >
            <Grid item xs={12}>
              {/* Abaixo Detalhes Item */}
              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="left"
                justify="left"
                display="flex"
                columns={12}
                bgcolor="#F5F5F5"
              >
                <Grid item xs={8}>
                  <Grid
                    container
                    spacing={0}
                    direction="row"
                    alignItems="left"
                    justify="left"
                    display="flex"
                    columns={12}
                  >
                    <Grid item xs={8}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Descrição:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.descricao}</Typography>
                    </Grid>
                    <Grid item xs={3.5}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>ID:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.codigo}</Typography>
                    </Grid>
                    <Grid item xs={0.5}>
                      <Box display="flex"
                        justifyContent="right"
                        variant={'rounded'}
                        alignItems="center"><Button bgcolor={'color'} onClick={(e) => fecharModalDetalhes(e)} startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '25px', width: 'auto' }} />} /></Box>

                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Nº Fabricante:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.n_original}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "##707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Marca:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto?.id_marcaNavigation?.descricao}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Embalagem:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.emb_venda} - {produto.embalagem_peca}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Prazo de Garantia:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.garantia}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Peso:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto?.peso?.toFixed(3).replace(".", ",")} Kg.</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Dimensões C x L x A:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{(produto?.comprimento != null ? produto?.comprimento.toFixed(2).replace(".", ",") : null)} x {(produto?.largura != null ? produto?.largura.toFixed(2).replace(".", ",") : null)} x {(produto?.altura != null ? produto?.altura.toFixed(2).replace(".", ",") : null)} cm</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço À Vista:</Typography><Typography sx={{ color: "#f44336", fontSize: "25px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-4px" }}>{(produto.a_vista != null ? produto.a_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)}</Typography>
                    </Grid>
                    <Grid item xs={4}>
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço de Tabela:</Typography><Typography sx={{ color: "#000000", fontSize: "22px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-1px" }}>{(produto.preco != null ? produto.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)}</Typography>
                    </Grid>
                    <Grid item xs={4}>                      
                      <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço Unitário x Quantidades:</Typography><Typography sx={{ color: "#000000", fontSize: "16px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-1px" }}>

                        {(produto.preco != null ? produto.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)} x {(produto?.quantidade != null ? produto?.quantidade : null)} = {
                        (produto?.preco != null ?
                          (produto?.quantidade * produto?.preco).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                        : 
                        null
                        )}                        
                      </Typography>
                    </Grid>

                    <Grid item xs={8}><Divider component="li" /></Grid>

                    {
                      (
                        produto.quantidadedisponivel <= 0
                          ?
                          <Button size="small" variant='contained' id={produto.codigo} value={produto.codigo} onClick={event => AviseMe(event, produto)} startIcon={<AddAlertIcon />} style={{ maxWidth: '115px', minWidth: '115px' }}>Avise-me</Button>
                          :
                          (
                            ItenJaNoCarrinho(produto)
                              ?

                              <Grid item xs={2}>
                                <Box sx={{ display: "flex", flex: 1, marginTop: '1px', alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px', width: '120px', maxWidth: '120px' }}>
                                  <IconButton name="Remover" onClick={event => RemoverCarrinho(event, produto)}>
                                    <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                                  </IconButton>

                                  <Box width={47}>
                                    <TextField
                                      hiddenLabel
                                      type="tel"
                                      name={produto.codigo} id={produto.codigo}
                                      value={produto.quantidade}
                                      //defaultValue="Small"
                                      fullWidth
                                      size="small"
                                      inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                      sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                      onChange={(event) => { handleChange(event, produto); }}
                                    />
                                  </Box>
                                  <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, produto)}>
                                    <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                                  </IconButton>
                                </Box>
                              </Grid>

                              :
                              <Button size="small" variant='contained' id={produto.codigo} value={produto.codigo} onClick={event => AdicionarCarrinho(event, produto)} startIcon={<AddShoppingCartIcon />} style={{ maxWidth: '115px', minWidth: '115px' }}>Comprar</Button>
                          )
                      )
                    }

                    <Grid item xs={2}><Divider sx={{ marginTop: '19px', marginLeft: '3px' }} /></Grid>

                  </Grid>
                </Grid>

                <Grid item xs={4}>

                  <Paper elevation={1} sx={{ marginTop: '5px', marginRight: '5px' }}>
                    <Box sx={{ minHeight: '250px', display: 'flex', alignItems: 'center' }}>
                      <CardMedia
                        component="img"
                        image={produto.caminho_imagem}
                        alt={produto.descricao}
                        sx={{ height: '100%', width: '100%', margin: 'auto', maxHeight: '250px', maxWidth: '2500px', padding: '10px', objectFit: 'contain' }}
                      />
                    </Box>
                  </Paper>

                </Grid>
              </Grid>

              {/* Acima Detalhes Item */}
            </Grid>

            <Grid item xs={7}>
              {/* Abaixo Detalhes Aplicação */}

              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="left"
                justify="left"
                display="flex"
                columns={12}
              >
                <Grid item xs={12} color="#707b7c" fontSize={"12px"} fontFamily={"Roboto"} marginLeft={"20px"} marginBottom={"2px"}>Aplicações:</Grid>
              </Grid>

              {
                aplicacoes.map((aplica, index) => (
                  <Grid
                    container
                    spacing={0}
                    alignItems="left"
                    justify="left"
                    display="flex"
                    columns={12}
                    marginLeft={"15px"}
                  >
                    <Grid item display={(!uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={12} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"} paddingTop={"5px"} >
                      {mostrarCampoOuImagem(aplica)}
                    </Grid>

                    <Grid item display={(uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={2} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"}>
                      {aplica.montadora}
                    </Grid>
                    <Grid item display={(uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={8} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"}>{aplica.aplicacao}</Grid>
                  </Grid>
                ))
              }

              <Grid item xs={12}><p></p></Grid>
              <Grid item xs={12}><p></p></Grid>
              <Grid item xs={12}><p></p></Grid>
              <Grid item xs={12}><p></p></Grid>

              {/* Acima Detalhes Aplicação */}
            </Grid>

            <Grid item xs={5}>

              {/* Abaixo Carrossel de Produtos */}
              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="left"
                justify="left"
                display="flex"
                columns={12}
              > <Typography sx={{ color: "#000000", fontSize: "15px", marginTop: "2px", marginLeft: "5px", textAlign: "left" }}>Veja se algum desses itens também pode te interessar:</Typography>
                <Carrossel_mini props={retornoApiSimultaneos} espacamento={100} itensPorPaginaView={3} />
              </Grid>
              {/* Acima Carrossel de Produtos */}

            </Grid>

            {/* Linha Em Branco no Final */}
            <Grid item xs={12}><Box sx={{ height: '40px' }}></Box></Grid>

          </Grid>
        </BrowserView>


        <MobileView>
          <Grid
            container
            spacing={0}
            direction="row"
            alignItems="left"
            justify="left"
            display="flex"
            columns={12}
            bgcolor="#F5F5F5"
          >

            {/* Abaixo Detalhes Item */}


            <Grid item xs={12}>
              <Paper elevation={1} sx={{ marginTop: '5px', marginRight: '5px', width: '100%' }}>
                <Box sx={{ minHeight: '250px', display: 'flex', alignItems: 'center' }}>
                  <CardMedia
                    component="img"
                    image={produto.caminho_imagem}
                    alt={produto.descricao}
                    sx={{ height: '100%', width: '98%', margin: 'auto', maxHeight: '300px', maxWidth: '2500px', padding: '10px', objectFit: 'contain' }}
                  />
                </Box>
              </Paper>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Descrição:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.descricao}</Typography>
            </Grid>
            <Grid item xs={11}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>ID:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.codigo}</Typography>
            </Grid>
            <Grid item xs={1}>
              <Box display="flex"
                justifyContent="right"
                variant={'rounded'}
                alignItems="center"><Button bgcolor={'color'} onClick={(e) => fecharModalDetalhes(e)} startIcon={<Avatar src={CloseIcon} variant={'square'} alignItems={'center'} sx={{ height: '25px', width: 'auto' }} />} /></Box>

            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Nº Fabricante:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.n_original}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "##707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Marca:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{(produto.id_marcaNavigation != null ? produto.id_marcaNavigation.descricao : null)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Embalagem:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.emb_venda} - {produto.embalagem_peca}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Prazo de Garantia:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{produto.garantia}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Peso:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{(produto.peso != null ? produto.peso.toFixed(3).replace(".", ",") : null)} Kg.</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Dimensões C x L x A:</Typography><Typography sx={{ fontSize: "15px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left" }}>{(produto.comprimento != null ? produto.comprimento.toFixed(2).replace(".", ",") : null)} x {(produto.largura != null ? produto.largura.toFixed(2).replace(".", ",") : null)} x {(produto.altura != null ? produto.altura.toFixed(2).replace(".", ",") : null)} cm</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço À Vista:</Typography><Typography sx={{ color: "#f44336", fontSize: "25px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-4px" }}>{(produto.a_vista != null ? produto.a_vista.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço de Tabela:</Typography><Typography sx={{ color: "#000000", fontSize: "22px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-1px" }}>{(produto.preco != null ? produto.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography sx={{ color: "#707b7c", fontSize: "12px", marginTop: "11px", marginLeft: "10px", textAlign: "left" }}>Preço Unitário x Quantidades:</Typography><Typography sx={{ color: "#000000", fontSize: "16px", fontWeight: "Bold", marginLeft: "10px", textAlign: "left", marginTop: "-1px" }}>

                        {(produto.preco != null ? produto.preco.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) : null)} x {(produto?.quantidade != null ? produto?.quantidade : null)} = {
                        (produto?.preco != null ?
                          (produto?.quantidade * produto?.preco).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
                        : 
                        null
                        )}                        


              </Typography>
            </Grid>

            <Grid item xs={6}><Divider component="li" /></Grid>
            <Grid item xs={4}>
              {
                (
                  produto.quantidadedisponivel <= 0
                    ?
                    <Button size="small" variant='contained' id={produto.codigo} value={produto.codigo} onClick={event => AviseMe(event, produto)} startIcon={<AddAlertIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Avise-me</Button>
                    :
                    (
                      ItenJaNoCarrinho(produto)
                        ?

                        <Grid item xs={2}>
                          <Box sx={{ display: "flex", flex: 1, marginTop: '1px', alignContent: "center", textAlign: "center", border: 1, borderRadius: 1, borderColor: "#ccc", height: '30px', width: '120px', maxWidth: '120px' }}>
                            <IconButton name="Remover" onClick={event => RemoverCarrinho(event, produto)}>
                              <RemoveIcon fontSize="small" sx={{ marginTop: '5px', marginLeft: '1px' }} />
                            </IconButton>

                            <Box width={47}>
                              <TextField
                                hiddenLabel
                                type="tel"
                                name={produto.codigo} id={produto.codigo}
                                value={produto.quantidade}
                                //defaultValue="Small"
                                fullWidth
                                size="small"
                                inputProps={{ min: 0, style: { textAlign: 'center', paddingLeft: '1px', paddingRight: '1px' } }}
                                sx={{ display: 'flex', textAlign: 'left', marginTop: '-4px', padding: '1px', minWidth: '45px', "& fieldset": { border: 'none', } }}
                                onChange={(event) => { handleChange(event, produto); }}
                              />
                            </Box>
                            <IconButton name="Adicionar" onClick={event => AdicionarCarrinho(event, produto)}>
                              <AddIcon fontSize="small" sx={{ marginTop: '5px', marginRight: '1px' }} />
                            </IconButton>
                          </Box>
                        </Grid>

                        :
                        <Button size="small" variant='contained' id={produto.codigo} value={produto.codigo} onClick={event => AdicionarCarrinho(event, produto)} startIcon={<AddShoppingCartIcon />} style={{ maxWidth: '110px', minWidth: '110px' }}>Comprar</Button>
                    )
                )
              }
            </Grid>
            <Grid item xs={2}><Divider sx={{ marginTop: '19px' }} /></Grid>

            <Grid item xs={12}>
              {/* Abaixo Detalhes Aplicação */}

              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="left"
                justify="left"
                display="flex"
                columns={12}
              >
                <Grid item xs={12} color="#707b7c" fontSize={"12px"} fontFamily={"Roboto"} marginLeft={"20px"} marginBottom={"2px"}>Aplicações:</Grid>
              </Grid>

              {
                aplicacoes.map((aplica, index) => (
                  <Grid
                    container
                    spacing={0}
                    alignItems="left"
                    justify="left"
                    display="flex"
                    columns={12}
                    marginLeft={"15px"}
                  >
                    <Grid item display={(!uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={12} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"} paddingTop={"5px"} >
                      {mostrarCampoOuImagem(aplica)}
                    </Grid>

                    <Grid item display={(uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={3.5} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"}>
                      {aplica.montadora}
                    </Grid>
                    <Grid item display={(uniqueValues.includes(aplica.fabricante) ? "block" : "none")} xs={8.5} style={{ color: aplicarCor(aplica) }} fontSize={"14px"} fontFamily={"Roboto"}>{aplica.aplicacao}</Grid>
                  </Grid>
                ))
              }

              {/* Acima Detalhes Aplicação */}
            </Grid>

            <Grid item xs={12}>

              <Grid
                container
                spacing={0}
                direction="row"
                alignItems="left"
                justify="left"
                display="flex"
                columns={12}
              >
                <Carrossel_mini props={retornoApiSimultaneos} espacamento={30} itensPorPaginaView={3}  />
              </Grid>

              <Grid item xs={12}><Box sx={{ height: '40px' }}></Box></Grid>

            </Grid>

          </Grid>
        </MobileView>

        {
          openDialogo ?
            <Dialogo
              cabecalho="Deseja Excluir do Carrinho"
              mensagem={dialogoMensagem}
              open={openDialogo}
              handleCloseNao={handleCloseNao.bind(this)}
              handleCloseSim={handleCloseSim.bind(this)}
            />
            : <div></div>
        }

        <ToastContainer />
      </>

      :

      <></>

    )
  )
 }

}
export default DetalhesProduto